import { PaperConfig } from './types';

/**
 * English Literature Paper 1 (1ET0/01)
 * - Section A: Shakespeare (extract + whole text essay)
 * - Section B: Post-1914 British Play or Novel
 */
export const englishLiteraturePaper1Config: PaperConfig = {
  paperCode: '1ET0/01',
  displayName: 'English Literature Paper 1',
  subject: 'English Literature',
  paperNumber: 'Paper 1',
  totalTimeMinutes: 105, // 1 hour 45 minutes

  sections: [
    {
      id: 'A',
      title: 'SECTION A',
      subtitle: 'Shakespeare',
      instructions: [
        'Answer BOTH questions in this section.',
        'You should spend about 55 minutes on this section.',
        'Write your answers in the spaces provided.',
      ],
      // SectionA_A = Extract analysis (Q1a), SectionA_B = Whole text essay (Q1b)
      categories: ['SectionA_A', 'SectionA_B'],
      timeGuidance: 55,
    },
    {
      id: 'B',
      title: 'SECTION B',
      subtitle: 'Post-1914 British Play or Novel',
      instructions: [
        'Answer the question on your studied text.',
        'You should spend about 50 minutes on this section.',
        'Write your answer in the space provided.',
      ],
      categories: ['SectionB'],
      timeGuidance: 50,
    },
  ],

  // Literature papers typically don't have a reading insert
  // The extract is embedded in the question
};
